import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { OrganisationService } from "@js/services/OrganisationService";
import { UserService } from "@js/services/UserService";
import { HasActiveLicense } from "@js/helpers/LicenseStatusHelper";

import {
  AccountClient,
  ApplicationUserClient,
  ApplicationUserCrudClient,
  BrokerAppraisal,
  BrokerAppraisalLender,
  ClaimClient,
  DealClientClient,
  DealCompletion,
  DealCompletionClient,
  FileAttachmentClient,
  Lender,
  LenderAppraisal,
  LenderClient,
  LocationEnum,
  MakeReferralMessageRequest,
  Organisation,
  OrganisationClient,
  PaymentClient,
  ProductClient,
  StaticDataClient,
  UserClient,
  WebConfigDTO,
} from "@src/apis/ModularClient";
import { RoleService } from "@js/services/RoleService";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class IndexController {
  fetchingResults: boolean = false;
  isPrimaryApplicant: boolean = true;

  profilePictureFullUrl: string;

  user: {
    id: number;
    email: string;
    firstName: string;
    isLegacyUser: boolean;
    profilePictureUrl: string;
    isOrganisationAdmin: boolean;
    organisationId: number;
    organisationReferralId: number;
    location: LocationEnum;
    defaultBrokerOrganisationId: number;
  };
  role: string;
  pageTitle: string;
  menuShrunk: boolean = false;
  errors: any[];
  copyrighttext: string;
  cookieMessageSeen: boolean;
  openShare: boolean;

  //Refer a friend
  referFriendName: string;
  referFriendSurname: string;
  referFriendEmail: string;

  //Generic share
  shareName: string;
  shareEmail: string;
  shareFriendsEmail: string;
  shareBody: string;

  //universal email send functions
  sendingsharemessage: boolean;
  sentsharemessage: boolean;

  //is Broker admin
  isAdminBroker: boolean = false;

  isIntroducer: boolean = false;
  isBroker: boolean = false;
  isLender: boolean = false;
  isClient: boolean = false;
  // is white labelling Org
  isWhiteLabelled: boolean = false;

  guidanceCheckbox: boolean = true;
  ShowHome: boolean = false;

  showMenu: boolean = false;

  showContactPopup: boolean = false;
  favIcon: HTMLLinkElement;
  title: HTMLLinkElement;
  companyWebsite: string;
  showContent: boolean = true;
  companyName: string = "Brickflow";
  companyUrlMenuIcon: string = null;
  footerTextFL: string;
  footerTextSL: string;
  footerTextTL: string;
  termsAndConditionsLink: string;
  privecyLink: string;
  cookiePolicyLink: string;
  productCode: string;
  nameInitial: string;
  openProfileImageSelection: boolean;
  brokerOrgNumber: string;

  displayIfInactiveSubscription: boolean = false;
  showBanner: boolean = false;
  viewProfileRole: string; // the role displayed on profile menu : "view your ___ profile"
  isNormalBroker: boolean = false;
  orgAdminEmail: string;

  isAssigningBrokerToOrg: boolean = false;
  isLegacyUser: boolean = false;

  hubspotContactUsBookMeeting: string = "";

  headerBackgroundColour: string = "";

  //deal completion
  brokerAppraisals: BrokerAppraisal[] = [];
  newDealCompletion = {} as DealCompletion;
  appraisalLenders: BrokerAppraisalLender[] = [];
  appraisalCompletionForm: ng.IFormController;
  appraisalName: string = "";
  showAppraisalNameDropdown: boolean = false;
  showAppraisalCompletionModal: boolean = false;
  filteredBrokerAppraisals: BrokerAppraisal[] = [];
  sendDealCompletionError: string = "";
  maxCompletionDate: Date = new Date();
  dataLoading: boolean = false;
  completionText: string;

  //Make a referral
  makeReferralForm: ng.IFormController;
  showMakeReferralModal: boolean = false;
  isSearchAttached?: boolean;
  isExistingSearch?: boolean;
  lenderReferralData: MakeReferralMessageRequest;
  message: string;
  showSubmitLenderReferralResponse: boolean = false;
  submitLenderReferralError: boolean = false;
  filteredLenderAppraisals: LenderAppraisal[] = [];
  lenderAppraisals: LenderAppraisal[] = [];
  hasLiveMarketSearch: boolean = false;
  isLenderReferralActive: boolean = false;
  contactDetails: string;
  showPage: boolean;
  loggedinUserLenderDetails: Lender;
  isInitialized = false;
  hasActiveSubscription: boolean;
  fullAvatarUrl: string = "";

  static $inject = [
    "$scope",
    "$rootScope",
    "$cookies",
    "$location",
    "$http",
    "AuthService",
    "RoleService",
    "AccountClient",
    "CaseService",
    "OrganisationService",
    "OrganisationClient",
    "UserService",
    "ApplicationUserClient",
    "UserClient",
    "FileAttachmentClient",
    "FileAttachmentHelper",
    "PaymentClient",
    "ProductClient",
    "DealCompletionClient",
    "DealClientClient",
    "LenderClient",
    "ClaimClient",
    "StaticDataClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "ODataHelper",
  ];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $auth: AuthService,
    protected roleService: RoleService,
    private accountClient: AccountClient,
    private caseService: CaseService,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
    private userService: UserService,
    private applicationUserClient: ApplicationUserClient,
    private userClient: UserClient,
    private fileAttachmentClient: FileAttachmentClient,
    private fileAttachmentHelper: FileAttachmentHelper,
    private paymentClient: PaymentClient,
    private productClient: ProductClient,
    private dealCompletionClient: DealCompletionClient,
    private dealClientClient: DealClientClient,
    private lenderClient: LenderClient,
    private claimClient: ClaimClient,
    private staticDataClient: StaticDataClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private indexService: IndexService,
    private odataHelper: ODataHelper,
  ) {
    this.setAuthorisation();

    // Used for test site to keep banner hidden
    if (localStorage.getItem("isTestBannerHidden")) {
      if (localStorage.getItem("isTestBannerHidden") == "true") {
        this.roleService.isTestBannerHidden = true;
      }
    }

    let d = new Date();
    (this.$rootScope as any).formSaved = true;
    this.footerTextTL = "Copyright © Property Funding Hub Limited " + d.getFullYear();

    //TODO once we are beyond 01/10/2025 we can remove the below logic and just show the new text.
    const firstOctober25 = Date.UTC(2025, 8, 30, 23, 0, 0);

    this.completionText =
      Date.now() >= firstOctober25
        ? "Please enter the following information so that we can send a gift to you or your borrower:"
        : "Please enter the following information so that we can send you and the borrower your complimentary completion gifts:";

    this.staticDataClient.getHubspotContactUsBookMeeting().then((hubSpotUrl: string) => {
      this.hubspotContactUsBookMeeting = hubSpotUrl;
    });

    this.accountClient.getFooterWebConfigValue().then((val: WebConfigDTO) => {
      this.termsAndConditionsLink = val.termsAndConditionsURL;
      this.privecyLink = val.privecyURL;
      this.cookiePolicyLink = val.cookiePolicyURL;
      this.headerBackgroundColour = val.headerBackgroundColour;
    });
    //$suppliers.fetchAll().then((response) => {
    //    response.forEach((supplier, index) => {
    //        if (!supplier.Coordinates) {
    //            this.$http.get("https://nominatim.openstreetmap.org/search?q=" + encodeURIComponent(supplier.Postcode) + "&format=json").then((response) => {
    //                supplier.Coordinates = response.data[0].lat + "," + response.data[0].lon;
    //                this.$suppliers.addUpdate(supplier);
    //            });
    //        }
    //    });
    //});

    if ($scope) {
      $rootScope.$on("login", (event: ng.IAngularEvent) => {
        this.roleService.IsAdminUser = false;
        this.roleService.IsLenderUserOrAbove = false;
        this.roleService.IsClientUserOrAbove = false;
        this.roleService.IsIntroducer = false;
        this.ShowHome = false;
        this.CalcShowHome();
        this.showPage = false;
        this.getCurrentUserForRequireAllDirective();
        this.runInitializationLogic(true);
        //  this.showHubSpotChat();
      });

      $rootScope.$on("error", (event: ng.IAngularEvent, data) => {
        if (!this.errors) {
          this.errors = [];
        }

        this.errors.push(data);
      });

      $rootScope.$on("clearerrors", (event: ng.IAngularEvent, page: string) => {
        this.clearErrors(page);
      });

      if (window.self == window.top) {
        $scope.$on("$viewContentLoaded", (event, next, current) => {
          this.cookieMessage();
          this.getGuidanceSwitchState();
        });

        $scope.$on("$routeChangeStart", async (event, next, current) => {
          this.setAuthorisation();
          this.getLeadGeneratorName();
          if ($cookies.get("access_token")) {
            $http.defaults.headers.common.Authorization = "Bearer " + $cookies.get("access_token");
            if (!(this.$rootScope as any)?.currentUser) await this.getCurrentUserForRequireAllDirective();

            if (
              $location.path() === "/usermanagement" ||
              $location.path() === "/rolemanagement" ||
              $location.path() === "/admindatadashboard" ||
              $location.path() === "/lenders"
            ) {
              const roles = (this.$rootScope as any)?.currentUser.Roles || [];
              const isAdmin = roles.includes("Admin");
              if (!isAdmin) {
                $location.path("/userdashboard");
              }
            }
          } else {
            this.showPage = true;
          }
        });
      }

      $rootScope.$on("logged-in", function (event: ng.IAngularEvent, token: string) {
        ($scope as any).ctrl.loggedIn = true;
        $http.defaults.headers.common.Authorization = "Bearer " + token;
        $location.url("/dashboard");
      });

      $scope.$on("$routeChangeSuccess", (event, current, previous) => {
        if (window.self == window.top)
          this.isAssigningBrokerToOrg = sessionStorage.getItem("assignUserToOrg") == "true";

        ($scope as any).ctrl.pageTitle = current.$$route.page;
        ($scope as any).ctrl.openSection = current.$$route.section;

        if (window.self == window.top && this.$cookies.get("access_token")) {
          ($scope as any).ctrl.$auth.setIsLoggedIn(true);
        }

        this.runInitializationLogic();
      });

      if (window.self == window.top) {
        $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
          this.updateGuidanceState();
        });
        $rootScope.$on("showContactPopup", (event: ng.IAngularEvent) => {
          this.showContactPopup = !this.showContactPopup;
        });
      }
    }
  }

  private async initialiseUserData() {
    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: await this.indexService.currentUserId } },
        select: {
          id: true,
          email: true,
          firstName: true,
          isLegacyUser: true,
          profilePictureUrl: true,
          isOrganisationAdmin: true,
          organisationId: true,
          organisationReferralId: true,
          location: true,
          fullName: true,
          defaultBrokerOrganisationId: true,
        },
      })
      .then((response) => {
        if (response.firstName != null && response.firstName.length > 0) {
          this.nameInitial = response.firstName.charAt(0);
        }
        this.isLegacyUser = response.isLegacyUser;

        if (response.profilePictureUrl != null && response.profilePictureUrl.length > 0) {
          this.fileAttachmentClient.getAmazonFileAccessUri(response.profilePictureUrl).then((result) => {
            this.profilePictureFullUrl = result;
          });
        }

        this.roleService.isOrganiationAdminUser().then((isOrgAdmin) => {
          this.isAdminBroker = isOrgAdmin;
          this.isNormalBroker = response.organisationId && !response.isOrganisationAdmin;
        });

        // If the user hasn't followed a whitelabelled link then "whitelabel" based on the user
        if (!this.$cookies.get("org_code") || (this.$cookies.get("org_code") && this.isLoggedIn)) {
          this.organisationService
            .getOrganisation()
            .then((org: Organisation) => {
              this.userService.fileSelected =
                org.logoURL != null &&
                  org.logoURL.length > 0 &&
                  org.hasWhiteLabelAddOnPaid == true &&
                  org.isWhiteLabelled == true
                  ? org.logoURL
                  : "img/BrickFlow_Logo_RGB_Blue.svg";
              this.isWhiteLabelled = org.hasWhiteLabelAddOnPaid && org.isWhiteLabelled;
              this.companyWebsite =
                org.hasWhiteLabelAddOnPaid == true && org.isWhiteLabelled == true
                  ? org.companyURL
                  : "https://brickflow.com";

              if (org.logoURL != null && org.logoURL.length > 0 && org.hasWhiteLabelAddOnPaid && org.isWhiteLabelled) {
                this.favIcon.href = org.faviconURL != null && org.faviconURL.length > 0 ? org.faviconURL : null;
                this.companyUrlMenuIcon = org.faviconURL ? this.favIcon.href : null;

                sessionStorage.setItem("companyLogoUrl", org.logoURL);
              }

              this.companyName = org.name;

              this.brokerOrgNumber = org.phoneNumber;

              if (org && org.id > 0) {
                this.organisationClient.getOrganisationAdmin(org.id).then((response) => {
                  this.orgAdminEmail = response;
                });
              }

              sessionStorage.setItem("companyWebsite", this.companyWebsite);

              if (!this.isWhiteLabelled) {
                if (this.user.defaultBrokerOrganisationId) {
                  if ((window as any).HubSpotConversations) {
                    (window as any).HubSpotConversations.widget.remove();
                  }
                }
                this.removeLSData();
              } else {
                if ((window as any).HubSpotConversations) {
                  (window as any).HubSpotConversations.widget.remove();
                }

                if (org.organisationTermForApp != null && org.organisationTermForApp.length > 0) {
                  sessionStorage.setItem("applicationName", org.organisationTermForApp);
                  this.$rootScope.$broadcast("applicationNameChanged", org.organisationTermForApp);
                  this.title.innerHTML = org.organisationTermForApp;
                }
              }
            })
            .finally(() => {
              this.buildFooterText(response);
            });
        } else {
          this.buildFooterText(response);

          if (location.pathname.replace("/", "") != null && location.pathname.replace("/", "").length > 0) {
            this.getOrganisationForWhiteLabelledUrl(response);
          }
        }
        this.roleService.GetUserRoles().then(async (roles) => {
          this.setViewProfileRole(roles);
          this.CalcShowHome();

          if (roles.find((x) => x.toLowerCase() == "broker")) {
            this.isPrimaryApplicant = false;
            this.isBroker = true;

            await this.validateUserLicense();

            this.organisationClient.getOrganisationAdmin(response.organisationId).then((response) => {
              this.orgAdminEmail = response;
            });
          }

          (this.$rootScope as any).userRoles = roles;
        });

        this.user = response;

        if (this.user.profilePictureUrl != null) {
          this.fileAttachmentClient.getAmazonFileAccessUri(this.user.profilePictureUrl).then((result) => {
            this.profilePictureFullUrl = result;
          });
        }
      });
  }

  whiteLabeling(organisationId: number) {
    if (organisationId) {
      this.organisationClient.fetch(organisationId).then((organisation) => {
        if (
          organisation &&
          organisation.isWhiteLabelled == true &&
          organisation.hasWhiteLabelAddOnPaid == true &&
          organisation.logoURL
        ) {
          this.fileAttachmentClient.getAmazonFileAccessUri(organisation.logoURL).then((result) => {
            this.userService.fileSelected = result;
          });
        } else {
          this.userService.fileSelected = "img/BrickFlow_Logo_RGB_Blue.svg";
        }
      });
    }
  }

  contactPopup(): void {
    this.showContactPopup = !this.showContactPopup;
  }

  cookieMessage() {
    if (!this.$cookies.get("cookieMessageSeen")) {
      this.cookieMessageSeen = false;
    } else {
      this.cookieMessageSeen = true;
    }
    return this.cookieMessageSeen;
  }
  cookieConsented() {
    this.cookieMessageSeen = true;
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    this.$cookies.put("cookieMessageSeen", "true", { expires: expiryDate });
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
  }

  getGuidanceSwitchState() {
    if (!this.$cookies.get("guidance")) {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "on") {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "off") {
      this.guidanceCheckbox = false;
    } else {
      this.guidanceCheckbox = true;
    }
    return this.guidanceCheckbox;
  }

  recordGuidanceCookie() {
    let guidanceSwitchState: string;
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    if (this.guidanceCheckbox == true) {
      guidanceSwitchState = "on";
    } else {
      guidanceSwitchState = "off";
    }
    this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
    this.$rootScope.$broadcast("guidanceStateChanged");
  }

  setAuthorisation() {
    if (this.$cookies.get("access_token") && !this.$http.defaults.headers.common.Authorization) {
      this.$http.defaults.headers.common.Authorization = "Bearer " + this.$cookies.get("access_token");
    }
  }

  clearErrors(page: string) {
    if (this.errors) {
      this.errors = this.errors.filter((value: any, index: number) => {
        return value.page !== page;
      });
    }
  }
  dismissError(index: number) {
    this.errors.splice(index, 1);
  }

  isMobile(): boolean {
    return window.innerWidth <= 451;
  }

  /*  displayDot() {
            var display = false;
            var hasLicense = this.user.licenseMasterId != null;
            if (!this.user.licenseMasterId && !this.user.subscriptionStatus) {
                this.$paymentClient.getLicense().then((response) => {
                    var licenseData = response;
                    if (response != null && response.Status != LicenseMasterStatusEnum.PreSubscription && response.Status != LicenseMasterStatusEnum.None) {
                        this.user.subscriptionStatus = licenseData.Status;
                        var invalidLicense = this.user.subscriptionStatus != LicenseMasterStatusEnum.PaidUp && this.user.subscriptionStatus != LicenseMasterStatusEnum.PreCancel && this.user.subscriptionStatus != LicenseMasterStatusEnum.PaymentProcessing;
                        this.displayIfInactiveSubscription = this.showBanner = invalidLicense;
                    } else {
                        var invalidLicense = this.user.subscriptionStatus != LicenseMasterStatusEnum.PaidUp && this.user.subscriptionStatus != LicenseMasterStatusEnum.PreCancel && this.user.subscriptionStatus != LicenseMasterStatusEnum.PaymentProcessing;
                        var display = !hasLicense || invalidLicense;
                        this.displayIfInactiveSubscription = this.showBanner = display;
                    }
                });
            } else {
                var invalidLicense = this.user.subscriptionStatus != LicenseMasterStatusEnum.PaidUp && this.user.subscriptionStatus != LicenseMasterStatusEnum.PreCancel && this.user.subscriptionStatus != LicenseMasterStatusEnum.PaymentProcessing;
                var display = !hasLicense || invalidLicense;
                this.displayIfInactiveSubscription = this.showBanner = display;
            }

        }*/

  CalcShowHome() {
    if ((this.$scope as any).ctrl.$auth.getIsLoggedIn() == false) {
      this.ShowHome = false;
    } else {
      if (
        (this.roleService.IsAdminUser && this.pageTitle == "Dashboard") ||
        (this.roleService.IsClient && this.pageTitle == "Client Dashboard") ||
        (this.roleService.IsLender && this.pageTitle == "Lenders")
      ) {
        this.ShowHome = false;
      } else {
        this.ShowHome = true;
      }
    }
  }

  GoHome() {
    if ((this.$scope as any).ctrl.$auth.getIsLoggedIn() == false) {
      return false;
    }

    this.roleService.goHomeBasedOnUser();
  }

  go(path: string) {
    if (this.$location.path() !== path) {
      this.$location.path(path);
    }
  }

  newloan() {
    (this.$rootScope as any).loanCriteria = null;
    this.$location.path("/criteria");
  }

  logout() {
    const broadcastResult = this.$rootScope.$broadcast("logout");

    if (broadcastResult.defaultPrevented) return;

    this.displayIfInactiveSubscription = false; //hide red dot

    delete this.user;
    this.$auth.logout();
    this.runInitializationLogic(true);
    //  this.showHubSpotChat();
  }

  newBlankCase() {
    this.fetchingResults = true;
    this.caseService.newBlankCase(this.isPrimaryApplicant).then((newBlankCaseDto) => {
      if (newBlankCaseDto && newBlankCaseDto.NewCaseId) {
        this.$location.path("/casedashboard/" + newBlankCaseDto.NewCaseId);
        this.fetchingResults = false;
      }
    });
  }

  /**Main menu link clicked (3 bricks icon button) */
  /**todo: add else outer statement for button to work when user is not logged in (not working at the moment)
   * else inner statement (userdashboard one) should do something similar to showHomeDashboard() method in "userdashboardcontroller.ts"
   */
  mainMenuLinkClicked() {
    if (this.$auth.isLoggedIn) {
      this.$auth.clearSelectedNavMenuAndFilterStorageData();

      if (this.roleService.IsAdminUser == true) {
        this.go("/dashboard");
      } else {
        this.go("/");
      }
    } else {
      this.go("/");
    }
  }

  goToNewUserDashboard() {
    // TODO - Temporary code JLH
    this.go("/userdashboard2");
  }

  homePageClicked() {
    let broadcastResult = this.$rootScope.$broadcast("logout");
    if (broadcastResult.defaultPrevented) return;
    window.location.href = this.companyWebsite;
  }

  showHubSpotChat() {
    this.organisationService.getOrganisation().then((userOrganisation: Organisation) => {
      // Hide the hubspot chat feature if the user's organisation is white-labelled
      if (
        userOrganisation.isWhiteLabelled == true &&
        userOrganisation.hasWhiteLabelAddOnPaid == true &&
        (window as any).HubSpotConversations
      ) {
        (window as any).HubSpotConversations.widget.remove();
      } else {
        if ((window as any).HubSpotConversations) {
          (window as any).HubSpotConversations.widget.load();
        }
      }
    });
  }

  removeLSData() {
    sessionStorage.removeItem("applicationName");
    sessionStorage.removeItem("companyWebsite");
    sessionStorage.removeItem("companyLogoUrl");
  }

  getOrganisationForWhiteLabelledUrl(user: {
    organisationId: number;
    isOrganisationAdmin: boolean;
    organisationReferralId: number;
  }) {
    this.showContent = false;
    this.organisationClient
      .findOrganisationByOrgCode(location.pathname.replace("/", ""))
      .then((userOrganisation: Organisation) => {
        if (userOrganisation != null) {
          if (
            userOrganisation.hasWhiteLabelAddOnPaid == true &&
            userOrganisation.isWhiteLabelled == true &&
            userOrganisation.organisationTermForApp != null &&
            userOrganisation.organisationTermForApp.length > 0
          ) {
            if (window.self == window.top) {
              sessionStorage.setItem("applicationName", userOrganisation.organisationTermForApp);
            } else {
              this.organisationService.sendDataToParent("applicationName", userOrganisation.organisationTermForApp);
            }
          } else {
            sessionStorage.removeItem("applicationName");
          }

          if (window.self == window.top && userOrganisation.companyURL) {
            sessionStorage.setItem("companyWebsite", userOrganisation.companyURL);
          } else {
            sessionStorage.removeItem("companyWebsite");
          }

          if (window.self == window.top && userOrganisation.logoURL) {
            sessionStorage.setItem("companyLogoUrl", userOrganisation.logoURL);
          } else {
            sessionStorage.removeItem("companyLogoUrl");
          }
        }
      })
      .finally(() => {
        this.showContent = true;
        this.buildFooterText(user);
      });
  }

  buildShareMsg() {
    const lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.shareBody =
        "Hi,\n\nI've just been trying out " +
        lsd +
        " - it’s a comparison site for specialist property finance, its's fast and it's really useful. You should check it out.";
    } else {
      this.shareBody =
        "Hi, \n\nI've just been trying out Brickflow - it’s a comparison site for specialist property finance, its's fast and it's really useful. You should check it out.";
    }
  }

  buildFooterText(user: { organisationId: number; isOrganisationAdmin: boolean; organisationReferralId: number }) {
    let lsd;
    if (window.self == window.top) lsd = sessionStorage.getItem("applicationName");
    if (!user && lsd != null) {
      this.footerTextFL = `${lsd} is designed to be used by brokers and property investors to source and apply for funding. It’s a collaborative project management tool, where you can store information and invite your colleagues to participate to make the application process quicker and easier.`;
      this.footerTextSL = null;
    } else {
      if (user && (this.isAdminBroker || user.organisationId > 0)) {
        this.footerTextFL =
          "Property Funding Hub Limited (t/a Brickflow) is designed to be used by mortgage brokers to source and apply for specialist property finance for their clients.";
        this.footerTextSL = null;
      } else if (user && user.organisationReferralId != null && user.organisationReferralId > 0) {
        this.footerTextFL = `${lsd} is designed to be used by brokers and property investors to source and apply for funding. It’s a collaborative project management tool, where you can store information and invite your colleagues to participate to make the application process quicker and easier.`;
        this.footerTextSL = null;
      } else {
        this.footerTextFL =
          "Property Funding Hub Limited (t/a Brickflow) is designed to be used by corporate borrowers (Limited Companies or Incorporated Partnerships) to compare and apply for specialist property finance loans.";
        this.footerTextSL =
          "Brickflow is not an advisory business and does not give advice. It can deal with purely factual inquiries and provide information but it will not give an opinion or recommendation in any circumstances.";
      }
    }
  }

  isLoggedIn(): boolean {
    return this.$auth.getIsLoggedIn();
  }

  /**
   * Called when a profile picture has been selected
   * @param files
   */
  async onFileSelect(files) {
    this.fileAttachmentHelper.uploadFileAndReturnURI(files).then(async (result) => {
      this.user.profilePictureUrl = result.fileLocation;

      this.user = await this.applicationUserCrudClient.patch({
        id: this.user.id,
        profilePictureUrl: this.user.profilePictureUrl,
      });

      this.fileAttachmentClient.getAmazonFileAccessUri(this.user.profilePictureUrl).then((result) => {
        this.profilePictureFullUrl = result;
      });

      this.openProfileImageSelection = false;
    });
  }

  toggleBanner() {
    this.showBanner = !this.showBanner;
  }

  setViewProfileRole(roles: string[]) {
    if (roles.find((x) => x.toLowerCase() == "admin")) this.viewProfileRole = "administrator";
    else if (roles.find((x) => x.toLowerCase() == "client")) this.viewProfileRole = "borrower";
    else if (roles.find((x) => x.toLowerCase() == "broker")) this.viewProfileRole = "broker";
    else if (roles.find((x) => x.toLowerCase() == "lender")) {
      this.viewProfileRole = "lender";
      this.isLender = true;
      this.lenderClient
        .getUserLenderDetails()
        .then((response) => {
          this.loggedinUserLenderDetails = response;
          this.hasLiveMarketSearch = response.hasLiveMarketSearch;
          this.isLenderReferralActive = response.isLenderReferralActive;
        })
        .finally(() => {
          if (this.hasLiveMarketSearch && this.isLenderReferralActive) {
            this.staticDataClient.getReferralContactDetails().then((response) => {
              this.contactDetails = response;
            });
          }
        });
    } else this.viewProfileRole = "";
  }

  getLeadGeneratorName() {
    if (!this.$cookies.get("leadgeneratorname")) {
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 1);

      this.productClient.getLeadGeneratorName().then((response) => {
        this.$cookies.put("leadgeneratorname", response, {
          expires: expiryDate,
        });
      });
    }
  }

  getFilteredBrokerAppraisals() {
    if (this.appraisalName != null && this.appraisalName.length > 0) {
      if (this.roleService.IsAdminUser) {
        if (this.appraisalName.trim().length >= 3) {
          this.dataLoading = true;
          this.dealCompletionClient
            .getBrokerAppraisalDetails(this.appraisalName)
            .then((response) => {
              this.filteredBrokerAppraisals = this.brokerAppraisals = response.brokerAppraisals;
            })
            .finally(() => {
              this.dataLoading = false;
            });
        }
      }
      else {
        this.filteredBrokerAppraisals = this.brokerAppraisals.filter(
          (appraisal) =>
            appraisal.appraisalName != null &&
            appraisal.appraisalName.toLowerCase().indexOf(this.appraisalName.toLowerCase()) !== -1,
        );
      }
    } else {
      this.filteredBrokerAppraisals = this.brokerAppraisals;
    }

    this.showAppraisalNameDropdown = true;
  }

  onSelectingAppraisalName(item: BrokerAppraisal) {
    this.appraisalName = item.appraisalName;
    this.showAppraisalNameDropdown = false;
    this.newDealCompletion.appraisalId = item.appraisalId;
    this.newDealCompletion.appraisalType = item.isDeal ? "Deal" : "Case";
    this.appraisalLenders = [];
    this.appraisalCompletionForm.lenderId.$setPristine();
    this.appraisalCompletionForm.lenderId.$setUntouched();
  }

  sendDealCompletionEmail() {
    this.dataLoading = true;
    this.newDealCompletion.lender = null;
    this.dealCompletionClient
      .sendDealCompletionEmail(this.newDealCompletion)
      .then((response) => {
        if (response) {
          this.showAppraisalCompletionModal = false;
        } else {
          this.sendDealCompletionError =
            "Your message could not be delivered. Please reach out to Brickflow so that we can investigate.";
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  onClickOfCompletion() {
    const modalContent = document.getElementsByClassName("modal-content");
    if (modalContent.length <= 0) {
      this.showAppraisalNameDropdown = false;
      this.newDealCompletion = {} as DealCompletion;
      this.appraisalName = "";
      this.sendDealCompletionError = "";
      this.appraisalLenders = [];
      this.showAppraisalCompletionModal = !this.showAppraisalCompletionModal;

      if (!this.roleService.IsAdminUser) {
        this.dataLoading = true;
        this.dealCompletionClient
          .getBrokerAppraisalDetails()
          .then((response) => {
            this.filteredBrokerAppraisals = this.brokerAppraisals = response.brokerAppraisals;
          })
          .finally(() => {
            this.dataLoading = false;
          });
      }

    }
  }

  closeAppraisalNameListDropDown() {
    event.stopPropagation();
    if (this.showAppraisalNameDropdown && !this.dataLoading) {
      this.showAppraisalNameDropdown = false;
    }
  }

  onClickOfCaseNameElement() {
    event.stopPropagation();
    if (!this.dataLoading) this.showAppraisalNameDropdown = !this.showAppraisalNameDropdown;
  }

  populateAppraisalLenders() {
    if (this.appraisalName.length > 0 && this.filteredBrokerAppraisals.length > 0) {
      this.appraisalLenders = this.filteredBrokerAppraisals.find(
        (b) => b.appraisalName == this.appraisalName,
      ).appraisalLenders;
    } else {
      this.appraisalLenders = [];
    }
  }

  onClickOfMakeAReferral() {
    const modalContent = document.getElementsByClassName("modal-content");
    if (modalContent.length <= 0) {
      this.lenderReferralData = {} as MakeReferralMessageRequest;
      this.appraisalName = "";
      this.showAppraisalNameDropdown = false;
      this.isSearchAttached = null;
      this.isExistingSearch = null;
      this.showSubmitLenderReferralResponse = false;
      this.submitLenderReferralError = false;
      this.showMakeReferralModal = !this.showMakeReferralModal;
      this.dataLoading = true;
      this.userClient
        .getLenderAppraisals()
        .then((response) => {
          this.filteredLenderAppraisals = this.lenderAppraisals = response;
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  submitLenderReferral() {
    this.dataLoading = true;
    if (!this.isSearchAttached) this.lenderReferralData.dealId = null;
    this.dealClientClient
      .submitLenderReferral(this.lenderReferralData)
      .then((response) => {
        if (response) {
          this.message = "Your referral has been submitted.";
          this.showSubmitLenderReferralResponse = true;
        } else {
          this.message = "Error while making a referral, please try later.";
          this.showSubmitLenderReferralResponse = true;
          this.submitLenderReferralError = true;
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  goToLoanTypeSelectionPage() {
    sessionStorage.setItem("lenderReferralReference", this.lenderReferralData.dealName);
    this.showMakeReferralModal = false;
    this.$location.path("/allloans");
  }

  closeLenderReferralModal() {
    this.showMakeReferralModal = false;
    if (
      this.$location.path().startsWith("/bridgingresults") ||
      this.$location.path().startsWith("/commercialresults") ||
      this.$location.path().startsWith("/devfinanceresults")
    ) {
      window.location.reload();
    }
  }

  onLenderSelectingSearchName(item: LenderAppraisal) {
    this.showAppraisalNameDropdown = false;
    this.appraisalName = item.dealName;
    this.lenderReferralData.dealId = item.dealId;
  }

  getFilteredLenderAppraisals() {
    if (this.appraisalName != null && this.appraisalName.length > 0) {
      this.filteredLenderAppraisals = this.lenderAppraisals.filter(
        (appraisal) =>
          appraisal.dealName != null &&
          appraisal.dealName.toLowerCase().indexOf(this.appraisalName.toLowerCase()) !== -1,
      );
    } else {
      this.filteredLenderAppraisals = this.lenderAppraisals;
    }

    this.showAppraisalNameDropdown = true;
  }

  hideHeader() {
    if (
      !this.$cookies.get("access_token") &&
      (this.$location.path().startsWith("/e/bridgingcriteria") ||
        this.$location.path().startsWith("/e/commercialcriteria") ||
        this.$location.path().startsWith("/e/devfinancecriteria") ||
        this.$location.path().startsWith("/allloans") ||
        this.$location.path().startsWith("/e/enterpriseleadcapture") ||
        this.$location.path().startsWith("/enterprise"))
    ) {
      return true;
    }
    return false;
  }

  hideFooter() {
    if (
      !this.$cookies.get("access_token") &&
      this.$location.path().includes("widget") &&
      window.self != window.top &&
      (this.$location.path().startsWith("/e/bridgingcriteria") ||
        this.$location.path().startsWith("/e/commercialcriteria") ||
        this.$location.path().startsWith("/e/devfinancecriteria") ||
        this.$location.path().startsWith("/allloans") ||
        this.$location.path().startsWith("/enterprise"))
    ) {
      return true;
    }
    return false;
  }

  isResultsPage() {
    if (
      this.$location.path().startsWith("/referredSearch") ||
      this.$location.path().startsWith("/resultsExternalAPI") ||
      this.$location.path().startsWith("/exitloanresults") ||
      this.$location.path().startsWith("/bridgingresults") ||
      this.$location.path().startsWith("/bridgingshortlistmore") ||
      this.$location.path().startsWith("/referredsearchdeal") ||
      this.$location.path().startsWith("/referredsearchcommercial") ||
      this.$location.path().startsWith("/referredsearchdevfinance") ||
      this.$location.path().startsWith("/commercialresults") ||
      this.$location.path().startsWith("/commercialshortlistmore") ||
      this.$location.path().startsWith("/devfinanceresults") ||
      this.$location.path().startsWith("/devfinanceshortlistmore") ||
      this.$location.path().startsWith("/results") ||
      this.$location.path().startsWith("/shortlistmore") ||
      this.$location.path().startsWith("/e/bridgingresults") ||
      this.$location.path().startsWith("/e/commercialresults") ||
      this.$location.path().startsWith("/e/devfinanceresults")
    ) {
      return true;
    } else {
      return false;
    }
  }

  goToNewSearch() {
    this.$location.path("/allloans");
  }

  async getCurrentUserForRequireAllDirective() {
    try {
      await this.indexService.initialise();
      (this.$rootScope as any).currentUser = await this.indexService.currentUser;
      (this.$rootScope as any).currentUser.Roles = await this.indexService.currentUserRoles;
      const licenseData = await this.indexService.currentUserLicenseData;
      (this.$rootScope as any).currentUser.features = licenseData.features;
      (this.$rootScope as any).currentUser.subscriptionStatus = licenseData.subscriptionStatus;
      this.hasActiveSubscription = HasActiveLicense(licenseData.subscriptionStatus);
    } finally {
      this.showPage = true;
    }
  }

  showSignInButton() {
    if (
      this.$location.path().startsWith("/e/bridgingresults") ||
      this.$location.path().startsWith("/e/commercialresults") ||
      this.$location.path().startsWith("/e/devfinanceresults")
    ) {
      return false;
    }
    return true;
  }
  //Runs only on firstload or onlogin
  async runInitializationLogic(reRun: boolean = false) {
    if (!this.isInitialized || reRun) {
      this.favIcon = document.querySelector("#appIcon");
      this.title = document.querySelector("#title");
      this.companyUrlMenuIcon = this.favIcon ? this.favIcon.href : null;

      if (window.self == window.top && this.$cookies.get("access_token")) {
        await this.initialiseUserData();
      } else {
        // If the user is not logged in, set showPage = true immediately.
        this.showPage = true;
        // default brickflow settings
        this.userService.fileSelected = "img/BrickFlow_Logo_RGB_Blue.svg";
        this.companyWebsite = "https://brickflow.com";
        //Below code is for displaying the application name
        if (location.pathname.replace("/", "") != null && location.pathname.replace("/", "").length > 0) {
          this.getOrganisationForWhiteLabelledUrl(null);
        } else {
          this.buildFooterText(null);
          if (window.self == window.top) this.removeLSData();
          this.favIcon.href = "favicon.ico";
          this.title.innerHTML = "Brickflow";
        }
      }

      this.isInitialized = true;
    }
  }

  async validateUserLicense() {
    const licenseData = await this.indexService.currentUserLicenseData;
    this.hasActiveSubscription = HasActiveLicense(licenseData.subscriptionStatus);

    const isValidLicense = !this.isBroker || this.hasActiveSubscription;

    sessionStorage.setItem("isValidLicense", isValidLicense.toString());

    if (!isValidLicense) {
      this.displayIfInactiveSubscription = this.showBanner = true;
    }
  }
}
